import { ValidationSchema } from '../../../../../../@types/validation-types'
import {
  defaultConstruction,
  defaultContactInfo,
  defaultDescription,
  useManualAndInternationalAddress,
  usePurchasePriceOnRequestCondition,
} from '../../../../../../services/validation/flow/defaultSchemas'
import { validationRules } from '../../../../../../services/validation/rules/validationRules'

export const propertyOwnerHouseSellSchema: ValidationSchema = {
  address: useManualAndInternationalAddress,
  basicInfo: {
    room: validationRules.room,
    livingSpace: validationRules.livingSpace,
    plotArea: validationRules.plotArea,
    price: usePurchasePriceOnRequestCondition,
  },
  description: { ...defaultDescription, adFurnishingNote: validationRules.adFurnishingNote },
  contactInfo: defaultContactInfo,
  construction: defaultConstruction,
  otherFacilities: {
    totalFloorsNumber: validationRules.totalFloors,
    noBathrooms: validationRules.noBathrooms,
    noBedrooms: validationRules.noBedrooms,
    usableArea: validationRules.usableArea,
    rentalIncome: validationRules.rentalIncome,
    parkingSpaceRent: validationRules.parkingSpaceRent,
    noParkingSpaces: validationRules.noParkingSpaces,
  },
}
